import getMuiTheme from 'material-ui/styles/getMuiTheme';

export default getMuiTheme({
  fontFamily: 'Raleway, Nunito, sans-serif',
  palette: {
    primary1Color: '#000B27',
    primary2Color: '#005b74',
    accent1Color: '#a8a8a8',
  },
  datePicker: {
    selectColor: '#000B27',
  }
});



// WEBPACK FOOTER //
// ./src/Theme.js